class Ajax {
    constructor() {
        this.pageSettings = {
            title: "",
            html: ""
        };
    }

    call(url, onSuccess, data, settings) {
        let xhr = new window.XMLHttpRequest();
        settings = app.util.mergeArray({
            type: "GET",
            showLoader: true,
            loaderParent: document.querySelector("body")
        }, settings);
        let loading = null;
        if (settings.showLoader) {
            loading = new Loading(settings.loaderParent);
            loading.show();
        }
        xhr.onSuccess = onSuccess;
        xhr.onreadystatechange = function () {
            if (xhr) {
                switch (xhr.readyState) {
                    case 2:
                        let location = xhr.getResponseHeader('X-Location');
                        if (location) {
                            window.location = location;
                            xhr = null;
                            return;
                        }
                        break;
                    case 4:
                        let responseData = {};

                        switch (xhr.status) {
                            case 0:
                                if (typeof settings.onError === "function") {
                                    settings.onError(responseData);
                                }
                                break;
                            case 200:
                                switch (xhr.getResponseHeader("Content-Type").toLowerCase()) {
                                    case "text/html; charset=utf-8":
                                        responseData.html = xhr.response;
                                        if (xhr.getResponseHeader("X-Title")) {
                                            responseData.title = decodeURIComponent(escape(atob(xhr.getResponseHeader("X-Title"))));
                                        }
                                        break;

                                    case "application/json":
                                        responseData = JSON.parse(xhr.response);
                                        break;
                                }
                                if (typeof (xhr.onSuccess) === "function") {
                                    xhr.onSuccess(responseData);
                                }
                                if (typeof (responseData.callback) === "string" && settings.type !== "POST_FORM") {
                                    eval(responseData.callback);
                                }
                                if (responseData.inject === true) {
                                    jQuery(responseData.into).html(responseData.content);
                                    if (typeof responseData.withHistory === "boolean" && responseData.withHistory === true) {
                                        window.history.pushState(null, window.location.title, xhr.responseURL);
                                    }
                                    app.events.pub(app.events.eventList.page_inject);
                                } else {
                                    if (responseData.modal === true) {
                                        if (responseData.clear === true) {
                                            app.modal.openClear(responseData.header, responseData.body, responseData.footer, responseData.cssClass, responseData.onOpenCallback, responseData.validateFormBeforeClosing, responseData.onCloseCallback);
                                        } else {
                                            app.modal.open(responseData.header, responseData.body, responseData.footer, responseData.cssClass, responseData.onOpenCallback, responseData.validateFormBeforeClosing, responseData.onCloseCallback);
                                        }
                                    } else {
                                        if (typeof responseData.reload === "string") {
                                            this.reload(responseData.reload);
                                        } else {
                                            if (responseData.alert === true) {
                                                app.alert.show(responseData.type, responseData.header, responseData.body, responseData.footer);
                                            }
                                        }
                                    }
                                }

                                break;

                            case 999:
                                app.alert.code(xhr.statusText, xhr.response);
                                break;

                            default:
                                switch (xhr.getResponseHeader("Content-Type").toLowerCase()) {
                                    case "application/json":
                                        responseData = JSON.parse(xhr.response);
                                        if (typeof (responseData.callback) === "string" && settings.type !== "POST_FORM") {
                                            eval(responseData.callback);
                                        }
                                        break;

                                    default:
                                        responseData.error = xhr.response;
                                        if (xhr.getResponseHeader("X-Title")) {
                                            responseData.title = xhr.getResponseHeader("X-Title");
                                        } else {
                                            responseData.title = 'Error';
                                        }
                                        break;
                                }
                                if (xhr.getResponseHeader("x-frame-options") === "SAMEORIGIN") {
                                    app.alert.error("Not allowed", "This is not allowed", "Contact support if this is not true for you")
                                }

                                if (typeof settings.onError === "function") {
                                    settings.onError(responseData);
                                } else {
                                    let title;
                                    let message;
                                    if (typeof responseData.title === "string") {
                                        title = responseData.title;
                                    } else {
                                        title = app.config.stdError.title;
                                    }
                                    if (typeof responseData.error === "string") {
                                        message = responseData.error;
                                    } else {
                                        message = app.config.stdError.body;
                                    }
                                    app.alert.error(title, message);
                                }
                                break;
                        }
                        if (settings.showLoader && loading) {
                            loading.hide();
                            loading = null;
                        }
                        break;
                }
            }
        }.bind(this);

        switch (settings.type) {
            case "DELETE":
            case "GET":
                let curl = url + app.util.ToQueryString(data);
                data = null;
                xhr.open(settings.type, curl, true);
                break;

            case "POST":
                xhr.open(settings.type, url, true);
                xhr.setRequestHeader("Content-type", "application/json");
                data = JSON.stringify(data);
                break;

            case "POST_FORM":
                xhr.open("post", url, true);
                break;
        }

        xhr.setRequestHeader("X-Requested-With", 'internal_async');
        xhr.setRequestHeader('cache-control', 'max-age=0');
        xhr.setRequestHeader('expires', 'Tue, 01 Jan 1980 1:00:00 GMT');
        xhr.setRequestHeader('pragma', 'no-cache');
        xhr.send(data);
    }

    prepare(url, data, type, onSuccess, onError, showLoader) {
        let options = {type: type};
        if (typeof onError === "function") {
            options.onError = onError;
        }
        if (typeof showLoader === "boolean") {
            options.showLoader = showLoader;
        }
        this.call(url, onSuccess, data, options);
    }

    post(url, data, onSuccess, onError, showLoader) {
        this.prepare(url, data, "POST", onSuccess, onError, showLoader);
    }

    postConfirm(url, data, onSuccess, onError, showLoader) {
        const box = app.alert.prompt(app.config.translate.are_you_sure, "<div class='d-sm-flex flex-sm-row-reverse justify-content-around'><div class='positive btn btn-green choice btn-block-xs-only'>" + app.config.translate.yes + "</div><div class='negative btn choice btn-block-xs-only btn-red' onclick='app.alert.close()'>" + app.config.translate.cancel + "</div></div>");
        $(box).find(".positive").on("click", () => {
            box.close();
            this.prepare(url, data, "POST", onSuccess, onError, showLoader);
        });
    }

    postForm(url, data, onSuccess, onError) {
        this.prepare(url, data, "POST_FORM", onSuccess, onError);
    }

    get(url, data, onSuccess, onError, showLoader) {
        this.prepare(url, data, "GET", onSuccess, onError, showLoader);
    }

    delete(url, data, onSuccess, onError) {
        this.prepare(url, data, "DELETE", onSuccess, onError);
    }

    deleteConfirm(url, data, onSuccess, onError) {
        const box = app.alert.prompt(app.config.translate.are_you_sure_you_want_to_delete, "<div class='d-sm-flex flex-sm-row-reverse justify-content-around'><div class='positive btn btn-green choice btn-block-xs-only'>" + app.config.translate.delete + "</div><div class='negative btn choice btn-block-xs-only btn-red' onclick='app.alert.close()'>" + app.config.translate.cancel + "</div></div>");
        $(box).find(".positive").on("click", () => {
            box.close();
            this.prepare(url, data, "DELETE", onSuccess, onError);
        });
    }

    put(url, data, onSuccess, onError) {
        this.prepare(url, data, "PUT", onSuccess, onError);
    }

    inject(url, target, withHistory = true, onSuccess, contextWindow, data = null) {
        let intoElement = (contextWindow || window).document.querySelector(target);
        if (intoElement) {
            this.call(url, function (data) {
                if (typeof data.html === "string") {
                    data = app.util.mergeArray(app.ajax.pageSettings, data);
                    (contextWindow || window).document.title = data.title;
                    if (withHistory) {
                        (contextWindow || window).history.pushState(null, data.title, url);
                    }
                    let html = "";
                    let root = jQuery(data.html);
                    if ("#" + root[0].id === target) {
                        html = root.html();
                    } else {
                        let search = root.find(target);
                        if (search.length) {
                            html = search.html();
                            search = null;
                        } else {
                            for (let i in root) {
                                if (root[i].outerHTML) {
                                    html += root[i].outerHTML;
                                }
                            }
                        }
                    }
                    jQuery(intoElement).innerHTML = "";
                    jQuery(intoElement).html(html);
                    intoElement = null;
                    root = null;
                    html = null;
                    app.events.pub("page_inject");
                    if (typeof onSuccess === 'function') {
                        onSuccess(data);
                    }
                } else {
                    if (typeof data.url === "string") {
                        app.ajax.inject(data.url, target, withHistory, onSuccess, contextWindow);
                    }
                }

            }, data, {loaderRoot: intoElement});
        }
    }

    reload(target = "#page", url, onSuccess, onError) {
        let intoElement = document.querySelector(target);
        if (intoElement !== null) {
            intoElement.isHidden = false;
            if (typeof url === "undefined" || url == null) {
                url = window.location;
            }
            this.call(url, function (data) {
                if (typeof data.html === "string") {
                    data = app.util.mergeArray(app.ajax.pageSettings, data);
                    let html = "";
                    const root = jQuery(data.html);
                    if ("#" + root[0].id === target) {
                        html = root.html();
                    } else {
                        const search = root.find(target);
                        if (search.length) {
                            html = search.html();
                        } else {
                            for (let i in root) {
                                if (root[i].outerHTML) {
                                    html += root[i].outerHTML;
                                }
                            }
                        }
                    }

                    jQuery(intoElement).html(html);
                    app.events.pub("page_reload");
                }

                if (typeof onSuccess === 'function') {
                    onSuccess(data);
                }
            }, null, {
                'loaderRoot': intoElement,
                'onError': function (data) {
                    if (typeof onError === 'function') {
                        onError(data);
                    }
                }
            });
        }
    }

    modal(url, cssClass, validateFormBeforeClose, onOpenCallback, onCloseCallback, triggerElement) {
        this.call(url, function (data) {
            if (typeof data.html === "string") {
                app.modal.open("", data.html, "", cssClass, onOpenCallback, validateFormBeforeClose, onCloseCallback, triggerElement);
            } else if (typeof data.header === "string") {
                app.modal.open(data.header, data.body, data.footer, cssClass, onOpenCallback, validateFormBeforeClose, onCloseCallback, triggerElement);
            }
            app.events.single("modal_open", () => {
                if (url.indexOf("#") > 0) {
                    let target = document.getElementById(url.substring(url.indexOf("#") + 1));
                    if (target) {
                        $("modal .modal-wrapper")[0].scrollBy(0, target.getBoundingClientRect().top - 80);
                    }
                }
            });
        });
    }

    modalClear(url, cssClass, validateFormBeforeClose, onOpenCallback, onCloseCallback, triggerElement) {
        this.call(url, function (data) {
            if (typeof data.html === "string") {
                app.modal.openClear("", data.html, "", cssClass, onOpenCallback, validateFormBeforeClose, onCloseCallback, triggerElement);
            } else if (typeof data.header === "string") {
                app.modal.openClear(data.header, data.body, data.footer, cssClass, onOpenCallback, validateFormBeforeClose, onCloseCallback, triggerElement);
            }
            app.events.single("modal_open", () => {
                if (url.indexOf("#") > 0) {
                    let target = document.getElementById(url.substring(url.indexOf("#") + 1));
                    if (target) {
                        $("modal .modal-wrapper")[0].scrollBy(0, target.getBoundingClientRect().top - 80);
                    }
                }
            });
        });
    }
}
